import { Box, Text } from "@mantine/core"

import { Loader } from "../Loader/Loader"

export const buildLabel = (
  label: React.ReactNode,
  isLoading?: boolean,
  required?: boolean
) => {
  if (!isLoading && !required) return label

  return (
    <Box display="flex">
      {label}
      {required && (
        <Text span c="var(--mantine-color-error)">
          *
        </Text>
      )}

      {isLoading && <Loader type="oval" size="xs" ml="xs" />}
    </Box>
  )
}
